import { CSSProperties } from 'react';

const BORDER_RADIUS = 8;
const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
};

export const toolLayoutStyles: Record<string, CSSProperties> = {
  desktopRow: {
    width: '100%',
    height: 'calc(100dvh - 70px)',
  },

  desktopMainColumn: {
    padding: '0 0 0 8px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  desktopSidebarCard: {
    height: 'calc(100% - 8px)',
    margin: '8px',
    position: 'relative',
  },

  desktopSidebarContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    overflowX: 'hidden',
  },

  desktopContent: {
    flex: 1,
    overflow: 'auto',
    overflowX: 'hidden',
    padding: 0,
  },

  desktopFooter: {
    padding: SPACING.sm,
    background: 'white',
    textAlign: 'center',
    borderTop: '1px solid #f0f0f0',
    lineHeight: 'normal',
    flexShrink: 0,
  },

  // Mobile styles
  mobileContainer: {
    width: '100vw',
    height: 'calc(100dvh - 110px)',
    display: 'flex',
    flexDirection: 'column',
  },

  mobileContent: {
    flex: 1,
    overflow: 'auto',
    padding: SPACING.sm,
  },

  mobileFooter: {
    padding: SPACING.sm,
    background: 'white',
    textAlign: 'center',
    borderTop: '1px solid #f0f0f0',
    lineHeight: 'normal',
    flexShrink: 0,
  },

  mobileMenuButton: {
    width: '38px',
    height: '38px',
    fontSize: '16px',
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: SPACING.sm,
    backgroundColor: 'black',
    color: 'white',
    margin: '8px',
  },

  // Mobile modal styles
  mobileModalContainer: {
    // height: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    position: 'relative',
  },

  mobileModalCloseButton: {
    position: 'absolute',
    top: SPACING.sm,
    right: SPACING.sm,
    zIndex: 1001,
    width: '40px',
    height: '40px',
    borderRadius: BORDER_RADIUS,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: '1px solid #f0f0f0',
    fontSize: '18px',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },

  mobileHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '50px',
    borderBottom: '1px solid #f0f0f0',
  },

  mobileModalContent: {
    flex: 1,
    overflow: 'auto',
    padding: 0,
    overflowX: 'hidden',
  },

  mobileModalFooter: {
    padding: SPACING.lg,
    background: 'white',
    borderTop: '1px solid #f0f0f0',
    // flexShrink: 0,
  },

  nextButton: {
    backgroundColor: 'black',
    color: 'white',
    width: '100%',
    height: '50px',
  },
};
